import { useState } from 'react';

import PartnerEditCompanyDialog from './PartnerEditCompanyDialog';

import type { Company } from '@/types';
import type { FC } from 'react';

import AdminCompanyEditDialog from '@/features/companyDashboard/common/AdminCompanyEditDialog';
import CompanyInfoPanel from '@/features/companyDashboard/common/CompanyInfoPanel';

const PartnerCompanyInfo: FC<{
  adminView?: boolean;
  company: Company;
  isCollapsed?: boolean;
  onCollapsedChange?: (isCollapsed: boolean) => void;
}> = ({ adminView = false, company, isCollapsed, onCollapsedChange }) => {
  const [isEditing, setIsEditing] = useState(false);

  const onEditing = () => setIsEditing(true);
  const onCloseEditing = () => setIsEditing(false);
  let editDialog = null;

  if (isEditing) {
    if (adminView) {
      editDialog = (
        <AdminCompanyEditDialog company={company} onClose={onCloseEditing} />
      );
    } else {
      editDialog = (
        <PartnerEditCompanyDialog company={company} onClose={onCloseEditing} />
      );
    }
  }

  return (
    <CompanyInfoPanel
      company={company}
      editDialog={editDialog}
      isCollapsed={isCollapsed}
      onCollapsedChange={onCollapsedChange}
      onEdit={onEditing}
    />
  );
};

export default PartnerCompanyInfo;
